import { connect } from 'react-redux';
import type { Hotel, PaleState } from '@/interfaces';
import displayValues from '@/resources/displayValues.json';
import { Amenity } from '../resultList/details/Amenity';
import { Distance } from '../resultList/details/Distance';
import { ImageRating } from '../resultList/images/ImageRating';

export type HotelDescription = Pick<
    Hotel,
    'name' | 'rating' | 'country' | 'region' | 'destination' | 'facilities' | 'activities' | 'distanceToBeach' | 'distanceToCity'
>;

export const HotelDescription = ({
    name,
    rating,
    country,
    region,
    destination,
    facilities,
    activities,
    distanceToBeach,
    distanceToCity,
}: HotelDescription) => {
    const hotelDestinationString = (): string | boolean => {
        const destinationCollection = [destination, region, country].filter(Boolean).join(' / ');
        return destinationCollection.length > 0 && destinationCollection;
    };

    return (
        <div data-testid="HotelDescription">
            <div className="u-stone u-title">{hotelDestinationString()}</div>
            <h1 className="u-licorice u-strong u-t2">{name}</h1>
            <div>
                <ImageRating id="HotelRating" rating={rating} bigStars emptyStars />
            </div>
            <div className="u-t4">
                <Distance distanceToBeach={distanceToBeach} distanceToCity={distanceToCity} />
            </div>
            <Amenity facilities={facilities} activities={activities} />
        </div>
    );
};

export const translateAmenities = (amenities: string[], translationMap: Record<string, string>): string[] =>
    amenities.reduce((translation: string[], amenity: string): string[] => {
        const translated = translationMap[amenity];
        return translated ? translation.concat(translated) : translation;
    }, []);

const mapStateToProps = ({ hotel }: PaleState): HotelDescription => ({
    name: hotel.name,
    rating: hotel.rating,
    country: hotel.country,
    region: hotel.region,
    destination: hotel.destination,
    facilities: translateAmenities(hotel.facilities, displayValues.amenities.facilities),
    activities: translateAmenities(hotel.activities, displayValues.amenities.activities),
    distanceToBeach: hotel.distanceToBeach,
    distanceToCity: hotel.distanceToCity,
});

export default connect(mapStateToProps)(HotelDescription);
